import { Divider, Box, Text } from '@cad-arc';
import { AttributeOption, CallForServiceOption } from '@mark43/cad-api';
import { SectionTitle } from '../../fr-event-common-components/section-title';
import { ASSIGNMENT_MODAL_COMMON_SIZE, ASSIGNMENT_MODAL_PADDING_TOP } from '../constants';
import { LocationRiskPriority } from '../../common/components/location-risk-priority';
import { DataPrivacy } from '../../common/components/datadog-privacy';

export function AssignmentModalDetailsCfs({
    callForService,
    additionalCallForServices,
    riskLevel,
    eventPriority,
    unmask = false,
}: {
    eventPriority?: AttributeOption;
    riskLevel?: AttributeOption;
    callForService?: CallForServiceOption;
    additionalCallForServices?: CallForServiceOption[];
    // Unmask the whole CFS section (label + value) for Datadog Session Replay — CFS is not PII
    // (RND-53990). Default false keeps it masked for other consumers of this component.
    unmask?: boolean;
}) {
    const additionalCallForServicesGrouped =
        additionalCallForServices?.length == 1
            ? additionalCallForServices[0].label
            : additionalCallForServices?.map((e) => e.label).join(', ') ?? '';

    if (!callForService) {
        return null;
    }

    const privacy = unmask ? 'unmask' : 'passthrough';
    return (
        <DataPrivacy privacy={privacy}>
            <Box>
                <SectionTitle title="CFS" />
                <Text fontSize={ASSIGNMENT_MODAL_COMMON_SIZE}>{callForService.label}</Text>
                {!!additionalCallForServices?.length && (
                    <Text fontSize={ASSIGNMENT_MODAL_COMMON_SIZE} style={{ whiteSpace: 'pre-wrap' }}>
                        Additional: {additionalCallForServicesGrouped}
                    </Text>
                )}
                <LocationRiskPriority
                    eventPriority={eventPriority}
                    riskLevel={riskLevel}
                    size={ASSIGNMENT_MODAL_COMMON_SIZE}
                />
                <Divider style={ASSIGNMENT_MODAL_PADDING_TOP} />
            </Box>
        </DataPrivacy>
    );
}
